export const initialData = [
  [Date.UTC(2024, 8, 18), 63139.71, 48012],
  [Date.UTC(2024, 8, 16), 63189.71, 48012],
  [Date.UTC(2024, 8, 16), 63129.71, 48012],
  [Date.UTC(2024, 8, 15), 63179.71, 48012],
  [Date.UTC(2024, 8, 14), 63159.71, 48012],
  [Date.UTC(2024, 8, 13), 63129.71, 18374],
  [Date.UTC(2024, 8, 12), 63400.25, 32487],
  [Date.UTC(2024, 8, 11), 63200.54, 14823],
  [Date.UTC(2024, 8, 10), 64535.67, 45784],
  [Date.UTC(2024, 8, 9), 64089.48, 38245],
  [Date.UTC(2024, 8, 8), 65845.62, 27342],
  [Date.UTC(2024, 8, 7), 62340.1, 12567],
  [Date.UTC(2024, 8, 6), 62865.72, 49678],
  [Date.UTC(2024, 8, 5), 61230.48, 39458],
  [Date.UTC(2024, 8, 4), 61750.21, 20123],
  [Date.UTC(2024, 8, 3), 60785.83, 34576],
  [Date.UTC(2024, 8, 2), 60570.44, 43754],
  [Date.UTC(2024, 8, 1), 62125.15, 25632],
  [Date.UTC(2024, 7, 31), 63390.18, 19748],
  [Date.UTC(2024, 7, 30), 62025.61, 44210],
  [Date.UTC(2024, 7, 29), 61400.39, 10458],
  [Date.UTC(2024, 7, 28), 63100.93, 47823],
  [Date.UTC(2024, 7, 27), 64950.32, 23674],
  [Date.UTC(2024, 7, 26), 64500.48, 19345],
  [Date.UTC(2024, 7, 25), 65120.83, 44857],
  [Date.UTC(2024, 7, 24), 63589.9, 34529],
  [Date.UTC(2024, 7, 23), 62234.49, 26538],
  [Date.UTC(2024, 7, 22), 60845.75, 18493],
  [Date.UTC(2024, 7, 21), 61950.13, 38723],
  [Date.UTC(2024, 7, 20), 61890.45, 15924],
  [Date.UTC(2024, 7, 19), 63240.3, 48156],
  [Date.UTC(2024, 7, 18), 64060.9, 29583],
  [Date.UTC(2024, 7, 17), 65320.14, 19782],
  [Date.UTC(2024, 7, 16), 64750.92, 43259],
  [Date.UTC(2024, 7, 15), 64210.77, 27645],
  [Date.UTC(2024, 7, 14), 65530.89, 16457],
  [Date.UTC(2024, 7, 13), 66140.26, 45102],
  [Date.UTC(2024, 7, 12), 63925.91, 38756],
  [Date.UTC(2024, 7, 11), 64680.34, 26578],
  [Date.UTC(2024, 7, 10), 62350.77, 35210],
  [Date.UTC(2024, 7, 9), 61120.66, 14058],
  [Date.UTC(2024, 7, 8), 61560.3, 42378],
  [Date.UTC(2024, 7, 7), 62250.91, 26597],
  [Date.UTC(2024, 7, 6), 63150.83, 48760],
  [Date.UTC(2024, 7, 5), 63900.24, 21853],
  [Date.UTC(2024, 7, 4), 65300.76, 39823],
  [Date.UTC(2024, 7, 3), 65950.49, 37854],
  [Date.UTC(2024, 7, 2), 62540.71, 10547],
  [Date.UTC(2024, 7, 1), 62860.32, 48239],
  [Date.UTC(2024, 6, 31), 63420.11, 22673],
  [Date.UTC(2024, 6, 30), 64560.45, 17493],
  [Date.UTC(2024, 6, 29), 65240.13, 40516],
  [Date.UTC(2024, 6, 28), 63120.89, 10925],
  [Date.UTC(2024, 6, 27), 61950.54, 45623],
  [Date.UTC(2024, 6, 26), 62400.77, 20634],
  [Date.UTC(2024, 6, 25), 63580.67, 13782],
  [Date.UTC(2024, 6, 24), 62900.52, 39842],
  [Date.UTC(2024, 6, 23), 61545.12, 26349],
  [Date.UTC(2024, 6, 22), 60800.78, 45768],
  [Date.UTC(2024, 6, 21), 61120.32, 27843],
  [Date.UTC(2024, 6, 20), 62250.61, 12908],
  [Date.UTC(2024, 6, 19), 63080.97, 18734],
  [Date.UTC(2024, 6, 18), 64870.24, 35624],
  [Date.UTC(2024, 6, 17), 65240.44, 41573],
  [Date.UTC(2024, 6, 16), 63900.88, 30489],
  [Date.UTC(2024, 6, 15), 63200.29, 28732],
  [Date.UTC(2024, 6, 14), 61950.41, 48102],
  [Date.UTC(2024, 6, 13), 62100.96, 10734],
  [Date.UTC(2024, 6, 12), 63750.12, 39625],
  [Date.UTC(2024, 6, 11), 62940.59, 31458],
  [Date.UTC(2024, 6, 10), 61460.21, 20487],
  [Date.UTC(2024, 6, 9), 60590.77, 14928],
  [Date.UTC(2024, 6, 8), 62120.99, 47632],
  [Date.UTC(2024, 6, 7), 63350.16, 36458],
  [Date.UTC(2024, 6, 6), 62900.11, 24398],
  [Date.UTC(2024, 6, 5), 64150.89, 28745],
  [Date.UTC(2024, 6, 4), 65790.34, 47293],
  [Date.UTC(2024, 6, 3), 63940.75, 10583],
  [Date.UTC(2024, 6, 2), 62550.19, 32982],
  [Date.UTC(2024, 6, 1), 61600.81, 28591],
  [Date.UTC(2024, 5, 30), 62070.44, 16784],
  [Date.UTC(2024, 5, 29), 61200.37, 47812],
  [Date.UTC(2024, 5, 28), 60080.77, 19482],
  [Date.UTC(2024, 5, 27), 61650.48, 34529],
  [Date.UTC(2024, 5, 26), 62230.93, 21534],
  [Date.UTC(2024, 5, 25), 63920.24, 46284],
  [Date.UTC(2024, 5, 24), 64840.34, 35972],
  [Date.UTC(2024, 5, 23), 63180.41, 20487],
  [Date.UTC(2024, 5, 22), 62110.89, 49128],
  [Date.UTC(2024, 5, 21), 62050.54, 15439],
  [Date.UTC(2024, 5, 20), 63540.77, 41235],
  [Date.UTC(2024, 5, 19), 60230.78, 18945],
  [Date.UTC(2024, 5, 18), 61500.32, 30958],
  [Date.UTC(2024, 5, 17), 62820.56, 27482],
  [Date.UTC(2024, 5, 16), 61150.43, 42973],
  [Date.UTC(2024, 5, 15), 62540.98, 35712],
  [Date.UTC(2024, 5, 14), 61400.59, 19845],
  [Date.UTC(2024, 5, 13), 62230.19, 48239],
  [Date.UTC(2024, 5, 12), 60900.76, 23958],
  [Date.UTC(2024, 5, 11), 61750.54, 36473],
  [Date.UTC(2024, 5, 10), 63520.24, 49123],
  [Date.UTC(2024, 5, 9), 62000.34, 17458],
  [Date.UTC(2024, 5, 8), 60780.13, 32895],
  [Date.UTC(2024, 5, 7), 62490.52, 25748],
  [Date.UTC(2024, 5, 6), 61650.71, 41984],
  [Date.UTC(2024, 5, 5), 63210.43, 29487],
  [Date.UTC(2024, 5, 4), 61830.89, 47382],
  [Date.UTC(2024, 5, 3), 60120.67, 19874],
  [Date.UTC(2024, 5, 2), 61370.58, 38729],
  [Date.UTC(2024, 5, 1), 62380.42, 15423],
  [Date.UTC(2024, 4, 31), 63590.16, 42874],
  [Date.UTC(2024, 4, 30), 60840.61, 26489],
  [Date.UTC(2024, 4, 29), 62000.32, 17243],
  [Date.UTC(2024, 4, 28), 64020.94, 31523],
  [Date.UTC(2024, 4, 27), 62900.71, 49381],
  [Date.UTC(2024, 4, 26), 61750.83, 18572],
  [Date.UTC(2024, 4, 25), 62590.21, 45278],
  [Date.UTC(2024, 4, 24), 61400.49, 29874],
  [Date.UTC(2024, 4, 23), 63240.85, 15783],
  [Date.UTC(2024, 4, 22), 62210.43, 37892],
  [Date.UTC(2024, 4, 21), 61520.67, 19345],
  [Date.UTC(2024, 4, 20), 60950.23, 32987],
  [Date.UTC(2024, 4, 19), 62040.98, 24563],
  [Date.UTC(2024, 4, 18), 63510.47, 43982],
  [Date.UTC(2024, 4, 17), 61870.21, 37289],
  [Date.UTC(2024, 4, 16), 62800.59, 18294],
  [Date.UTC(2024, 4, 15), 61040.34, 49857],
  [Date.UTC(2024, 4, 14), 62090.89, 24892],
  [Date.UTC(2024, 4, 13), 63110.72, 38721],
  [Date.UTC(2024, 4, 12), 61350.84, 16843],
  [Date.UTC(2024, 4, 11), 62540.51, 45612],
  [Date.UTC(2024, 4, 10), 61970.32, 27981],
  [Date.UTC(2024, 4, 9), 63200.61, 32458],
  [Date.UTC(2024, 4, 8), 61490.18, 15476],
  [Date.UTC(2024, 4, 7), 62370.23, 43729],
  [Date.UTC(2024, 4, 6), 62800.99, 29874],
  [Date.UTC(2024, 4, 5), 61250.73, 13548],
  [Date.UTC(2024, 4, 4), 61940.86, 49213],
  [Date.UTC(2024, 4, 3), 62670.38, 20348],
  [Date.UTC(2024, 4, 2), 61100.74, 38562],
  [Date.UTC(2024, 4, 1), 62750.42, 18456],
  [Date.UTC(2024, 3, 30), 61500.33, 28934],
  [Date.UTC(2024, 3, 29), 62290.97, 15834],
  [Date.UTC(2024, 3, 28), 61030.43, 47862],
  [Date.UTC(2024, 3, 27), 62540.54, 35478],
  [Date.UTC(2024, 3, 26), 62860.89, 29382],
  [Date.UTC(2024, 3, 25), 61200.41, 45623],
  [Date.UTC(2024, 3, 24), 63040.28, 18793],
  [Date.UTC(2024, 3, 23), 61850.92, 39745],
  [Date.UTC(2024, 3, 22), 62230.14, 23564],
  [Date.UTC(2024, 3, 21), 61040.77, 48732],
  [Date.UTC(2024, 3, 20), 62950.13, 19847],
  [Date.UTC(2024, 3, 19), 61720.84, 34782],
  [Date.UTC(2024, 3, 18), 61230.56, 19573],
  [Date.UTC(2024, 3, 17), 62460.22, 46731],
  [Date.UTC(2024, 3, 16), 62990.31, 35874],
  [Date.UTC(2024, 3, 15), 61440.53, 19845],
  [Date.UTC(2024, 3, 14), 62170.12, 38573],
  [Date.UTC(2024, 3, 13), 61930.99, 24859],
  [Date.UTC(2024, 3, 12), 63100.27, 49281],
  [Date.UTC(2024, 3, 11), 62830.98, 30567],
  [Date.UTC(2024, 3, 10), 61560.73, 19764],
  [Date.UTC(2024, 3, 9), 62700.44, 42189],
  [Date.UTC(2024, 3, 8), 61190.24, 25734],
  [Date.UTC(2024, 3, 7), 62050.92, 38514],
  [Date.UTC(2024, 3, 6), 61470.12, 29478],
  [Date.UTC(2024, 3, 5), 63080.44, 48212],
  [Date.UTC(2024, 3, 4), 62140.32, 15734],
  [Date.UTC(2024, 3, 3), 62950.75, 32487],
  [Date.UTC(2024, 3, 2), 61540.63, 18954],
  [Date.UTC(2024, 3, 1), 62630.78, 49673],
  [Date.UTC(2024, 2, 31), 61250.13, 23647],
  [Date.UTC(2024, 2, 30), 61980.88, 18732],
  [Date.UTC(2024, 2, 29), 63250.71, 47983],
  [Date.UTC(2024, 2, 28), 62560.56, 29465],
  [Date.UTC(2024, 2, 27), 61170.49, 18573],
  [Date.UTC(2024, 2, 26), 62380.12, 49562],
  [Date.UTC(2024, 2, 25), 63140.89, 21843],
  [Date.UTC(2024, 2, 24), 61750.61, 34923],
  [Date.UTC(2024, 2, 23), 61000.34, 18659],
  [Date.UTC(2024, 2, 22), 62470.73, 49312],
  [Date.UTC(2024, 2, 21), 61490.11, 21794],
  [Date.UTC(2024, 2, 20), 62360.78, 36574],
  [Date.UTC(2024, 2, 19), 63120.56, 15678],
  [Date.UTC(2024, 2, 18), 61370.23, 48721],
  [Date.UTC(2024, 2, 17), 62840.71, 29543],
  [Date.UTC(2024, 2, 16), 61610.94, 27634],
  [Date.UTC(2024, 2, 15), 62390.48, 45278],
  [Date.UTC(2024, 2, 14), 61230.32, 18473],
  [Date.UTC(2024, 2, 13), 62500.61, 37128],
  [Date.UTC(2024, 2, 12), 62940.23, 23984],
  [Date.UTC(2024, 2, 11), 61670.92, 49762],
  [Date.UTC(2024, 2, 10), 61890.43, 26843],
  [Date.UTC(2024, 2, 9), 63020.57, 35124],
  [Date.UTC(2024, 2, 8), 61780.86, 19834],
  [Date.UTC(2024, 2, 7), 62990.73, 48621],
  [Date.UTC(2024, 2, 6), 61050.64, 29512],
  [Date.UTC(2024, 2, 5), 62610.45, 37485],
  [Date.UTC(2024, 2, 4), 62030.98, 24689],
  [Date.UTC(2024, 2, 3), 63000.72, 47598],
  [Date.UTC(2024, 2, 2), 61390.84, 28457],
  [Date.UTC(2024, 2, 1), 62870.43, 19382],
  [Date.UTC(2024, 1, 29), 62050.23, 32794],
  [Date.UTC(2024, 1, 28), 61910.72, 26489],
].reverse();
